import { useNavigate } from 'react-router-dom';

import Page from '@/components/layout/Page';
import Loader from '@/components/common/Loader';
import HeaderWithBack from '@/components/common/HeaderWithBack';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { format } from 'date-fns';

import AvailabilityCalendar from './components/AvailabilityCalendar';

import { useAvailabilitySelf } from '@/data/availability';

const Availability = () => {
  const availabilities = useAvailabilitySelf();
  const navigate = useNavigate();

  const handleSelect = (date) => {
    const formattedDate = format(date, 'yyyy-MM-dd');
    navigate(`/availability/${formattedDate}`);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Availability</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="max-w-fit mx-auto">
          <AvailabilityCalendar
            availabilities={availabilities.data}
            onSelect={handleSelect}
          />
        </div>
      </CardContent>
    </Card>
  );
};

const AvailabilityPage = () => {
  const availabilities = useAvailabilitySelf();

  if (availabilities.isLoading && !availabilities.data) {
    return (
      <Page>
        <HeaderWithBack to="/availability" title="Calendar" />
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <Loader />
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <HeaderWithBack to="/setting" title="Settings" />
      <div className="pb-20">
        <Availability />
      </div>
    </Page>
  );
};

export default AvailabilityPage;
